// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_featured = /** @type {(inputs: {}) => string} */ () => {
	return `featured`
};

const el_featured = /** @type {(inputs: {}) => string} */ () => {
	return `προτεινόμενα`
};

const ru_featured = /** @type {(inputs: {}) => string} */ () => {
	return `рекомендуемые`
};

const he_featured = /** @type {(inputs: {}) => string} */ () => {
	return `מומלצים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const featured = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.featured(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("featured", locale)
	if (locale === "en") return en_featured(inputs)
	if (locale === "el") return el_featured(inputs)
	if (locale === "ru") return ru_featured(inputs)
	if (locale === "he") return he_featured(inputs)
	return "featured"
};